import React from "react";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Categories from "@/components/Categories";
import WhyChooseUs from "@/components/WhyChooseUs";
import HospitalProduct from "@/components/HospitalProduct";
import FeaturedProducts from "@/components/FeaturedProducts";
import Compliance from "@/components/Compliance";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import { Footer } from "@/components/Footer";

const HomePage = () => {
  return (
    <>
      <main>
        <Hero />
        <About />
        <Categories />
        <WhyChooseUs />
        <HospitalProduct />
        <FeaturedProducts />
        <Compliance />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
